
import Carousel from '../carousel'
import {enterInfo} from '@mixins'
import {jump,util} from '@utils'
import { mapState } from 'vuex'
export default {
    mixins:[enterInfo],
    components:{Carousel},
    props:{
        list:{
            type:Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            serveIndex:0,
            options:{

            }
        }
    },
    computed:{
        ...mapState(['userInfo']),
    },
    watch:{
        list(newVal){
            if(newVal && newVal.length > 0) {
                const listMaxIndex = newVal.length - 1;
                const index = listMaxIndex > 1 ? 1: listMaxIndex;
                this.gotoIndex(index)
            }
        }
    },
    mounted(){
        this.carousel = this.$refs.carousel;
    },
    methods: {
        next() {
            if(this.serveIndex < this.list.length - 1) {
                ++this.serveIndex;
                this.carousel.next();
            }

        },

        prev() {
            if(this.serveIndex > 0) {
                --this.serveIndex;
                this.carousel.prev();
            }
            
        },
        gotoIndex(index){
            this.serveIndex = index >=0 ? index : 0;
            this.carousel.goto(this.serveIndex);  
        },
        toDetail(item){
            if(!item.isNeedLogin) {
                window.open(item.url, '_blank');
                
            } else if(util.ensureLogin()){
                if(this.NOBIND) {
                    jump.enterManage();
                } else {
                    if(item.buzzType && item.buzzType != this.userInfo.buzzType) {
                        jump.serveManage();
                    } else {
                        window.open(item.url, '_blank');
                    } 
                }
            }
        }
        
  }
}